import React from "react";
import CurrencyFormat from "react-currency-format";
import { useReactToPrint } from "react-to-print";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LinkValues, ResponseValues } from "../../../values/strings";
import { useCoreRequestProvider } from "../../../providers/RequestProvider";
import { useThemeProvider } from "../../../providers/ThemeProvider";
import { ExternalDepositWalletListViewComponent } from "../../listview/ExternalDepositWalletListViewComponent";
import { useLanguageProvider } from "../../../providers/LanguageProvider";
import QRCode from "react-qr-code";

export const ExternalDepositWalletMainPageComponent = ({
  urlParams,
  autoOpenApp = false,
}) => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const theme = useThemeProvider();
  const coreRequest = useCoreRequestProvider();
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(async () => {
    if (isLoading === true) {
      const data = await coreRequest.post(
        LinkValues.core.finance.transaction.externaldepositwallet(),
        {
          address: urlParams.senderEmail,
          code: urlParams.code,
        }
      );
      if (data.status === 200) {
        if (data.data.has_error === false) {
          window.location.href = data.data.response.url;
        } else {
          setHasError(true);
        }
      }
      setIsLoading(false);
    }
  }, [isLoading]);

  const OnClickPay = () => {
    setIsLoading(true);
  };

  const buildReceipt = () => (
    <Container maxWidth="xs" disableGutters={true}>
      <Box
        style={{
          direction: lang.textDirection(),
          backgroundColor: theme.theme.palette.secondary.main,
          padding: 1,
          margin: "auto",
        }}
      >
        <Box
          style={{
            backgroundColor: theme.theme.palette.theme.main,
            borderRadius: "0 0 7px 7px",
            padding: 3,
          }}
        >
          <Grid container item direction="column">
            {/* <Grid
              container
              item
              direction="row"
              paddingX={3}
              paddingY={1}
              columnSpacing={2}
            >
              <Grid container item xs="auto" alignItems="center">
                <img
                  src={LinkValues.images.icons.navHeaderLight()}
                  hidden={theme.theme.palette.mode != "light"}
                  style={{ height: 40 }}
                />
                <img
                  src={LinkValues.images.icons.navHeaderDark()}
                  hidden={theme.theme.palette.mode != "dark"}
                  style={{ height: 40 }}
                />
              </Grid>
              <Grid container item xs direction="column">
                <Typography variant="title">{t("app_name")}</Typography>
                <Typography variant="caption">
                  {t("app_description")}
                </Typography>
              </Grid>
            </Grid> */}
            <Grid container item direction="row" paddingY={1} columnSpacing={2}>
              <Grid container item xs="auto" alignItems="center">
                <Box
                  style={{
                    width: 4,
                    height: "100%",
                    backgroundColor: theme.theme.palette.primary.main,
                  }}
                ></Box>
              </Grid>
              <Grid
                container
                item
                xs
                direction="column"
                paddingX={1}
                paddingY={2}
              >
                <Typography variant="h6">{t("depositToWallet")}</Typography>
                <Typography variant="caption"></Typography>
              </Grid>
            </Grid>
            <Grid container item direction="column" paddingX={1} paddingY={1}>
              <ExternalDepositWalletListViewComponent
                sender={urlParams.senderEmail}
                receiver="rxFebxh94rRNoVeZtc8kzjAv5o6ZNwAzNagdWMDU7rb"
                amount={
                  <CurrencyFormat
                    value={urlParams.amount}
                    displayType="text"
                    thousandSeparator={true}
                  />
                }
                currency="IRT"
                transactionType={t("deposit")}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            backgroundColor: theme.theme.palette.theme.main,
            borderTopColor: theme.theme.palette.secondary.main,
            borderTopWidth: 1,
            borderTopStyle: "dashed",
            borderRadius: "7px 7px 0 0",
          }}
        >
          {/* <Grid container direction="row" paddingX={3} columnSpacing={2}>
            <Grid container item xs direction="column">
              <Typography variant="title">{t("serviceProvider")}</Typography>
              <Typography variant="caption">
                {t("app_name")} - {t("app_description")}
              </Typography>
            </Grid>
          </Grid> */}
        </Box>
      </Box>
    </Container>
  );
  return (
    <div>
      <Box
        marginY={5}
        className={theme.styles.classes.componentsTransactionReceipt}
      >
        <Grid container item direction="column">
          {typeof urlParams.amount !== "string" ||
          /^\d+$/.test(urlParams.amount) === false ? (
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid container item direction="column" xs={12}>
                <Typography variant="navBar">
                  {t("errorAmountIsNotValid")}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {(hasError && (
                <Grid container item direction="column">
                  <Typography
                    variant="navBar"
                    sx={{
                      padding: 4,
                      backgroundColor: "#c55",
                    }}
                  >
                    {t("errorOperationFailed")}
                  </Typography>
                </Grid>
              )) || <></>}
              <Grid container item direction="column">
                {buildReceipt()}
              </Grid>
              <Grid container item direction="column">
                <Typography
                  variant="navBar"
                  sx={{
                    padding: 2,
                    margin: 1,
                    borderRadius: 1,
                    backgroundColor: "rgb(129 248 238)",
                    color: "#000",
                  }}
                >
                  در صورت بروز هرگونه مشکل در پرداخت با "
                  <a
                    style={{
                      color: "rgb(0 0 255)",
                      fontWeight: 500,
                    }}
                    href="https://t.me/vipino_2"
                  >
                    پشتیبانی فروشنده
                  </a>
                  " در ارتباط باشید.
                </Typography>
              </Grid>
              <Grid container item direction="row" padding={1} spacing={1}>
                <Grid container item direction="column" xs={12}>
                  <Button
                    color={"primary"}
                    variant="contained"
                    onClick={OnClickPay}
                    disableElevation
                    disableRipple
                    disabled={isLoading}
                  >
                    <Typography variant="navBar">{t("payNow")}</Typography>
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </div>
  );
};
